import { mergeStyles } from '@cian/utils';
import React, { FC, ReactNode } from 'react';
import styles from './Link.css';

interface IProps {
  className?: string;
  target?: string;
  title?: string;
  href?: string;
  rel?: string;
  role?: string;
  children?: ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?(e?: any): void;
}

export const Link: FC<IProps> = ({ title, target, href, rel, role, className, onClick, children }) => {
  return (
    <a
      title={title}
      target={target}
      href={href}
      rel={rel}
      role={role}
      {...mergeStyles([styles['link-default'], className])}
      onClick={e => onClick?.(e)}
    >
      {children}
    </a>
  );
};
